import React from "react"

export default function Phone() {
  return (
    <symbol id="svg-select-phone" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M27.6,21.9c-1-1-2.1-1.7-3.2-2c-1.3-0.4-2.5-0.1-3.5,0.9c-0.8,0.9-1.6,1.8-2.8,1.1c-2.6-1.8-6.4-5.6-8.2-8.2  c-0.7-1,0-1.8,0.8-2.6c0.1-0.1,0.1-0.2,0.2-0.2c0.7-0.7,1.1-1.5,1.1-2.4c0-1.3-0.8-2.9-2.2-4.2c-1.4-1.4-3-2.6-4.8-1.5  C3.8,3.6,2.9,5.7,2.7,6.6c-0.6,2.2-0.6,4.5,0.1,6.6C4.5,17.9,14,27.3,18.7,29.1c1.1,0.4,2.2,0.6,3.4,0.6c1.1,0,2.1-0.2,3.2-0.5  c1.1-0.3,3.2-1.2,3.8-2.4C30.1,24.8,28.9,23.3,27.6,21.9z M9.1,14.4c1.7,2.7,5.9,6.7,8.4,8.5c1.6,1,2.9,0.2,4.4-1.2  c0.4-0.5,0.9-0.7,1.5-0.7l0,0c1.3,0,2.6,1.1,3.3,1.8c1.5,1.5,1.8,2.3,1.3,3.3c-0.7,1-4.7,3.3-8.9,1.8C14.7,26.3,5.4,17.1,3.9,12.8  C2.4,8.5,4.6,4.5,5.7,3.9C6,3.7,6.3,3.6,6.6,3.6c0.7,0,1.4,0.5,2.4,1.5c0.7,0.7,1.8,2,1.8,3.4c0,0.6-0.2,1.1-0.7,1.5  C8.6,11.6,7.9,12.8,9.1,14.4z"
      />
    </symbol>
  )
}
